export const AUTH_API_ACCESS_TOKEN: string = "auth.api.access_token";
export const AUTH_ID_TOKEN: string = "auth.id_token";
export const AUTH_API_ACCESS_TOKEN_EXPIRES_AT: string =
  "auth.api.access_token_expires_at";

export const SESSION_EXPIRES_AT: string = "session.expires_at";

export const USER_ID: string = "user.id"; // represents the user.id pk
export const AUTH0_USER_ID: string = "auth0_user.id"; // represents auth0 unique-id for user
export const USER_TYPE: string = "user.type";
export const USER_EMAIL: string = "user.email";
export const USER_FIRST_NAME: string = "user.first_name";
export const USER_LAST_NAME: string = "user.last_name";
export const USER_PHONE_NUMBER: string = "user.phone_number";
export const USER_EMAIL_VERIFIED: string = "user.email_verified";
export const USER_ORIGINATED_FROM: string = "user.originated_from";
export const USER_EVENT_STATE: string = "user.event_state";
export const TOKEN: string = "TOKEN"
export const RID: string = "RID"
export const UUID: string = "UUID"
export const CID: string = "CID"
export const UID: string = "UID" // user ID